<template>
  <div>
    <div v-if="resumePermissions">
      <ResumeInfo></ResumeInfo>
    </div>
    <div v-else>

      <el-card>
        <div slot="header" class="clearfix" style="text-align: center">
          <span style="font-weight: bold;font-size: 20px;">简历验证</span>
        </div>
        <div style="width: 500px;margin: 0 auto">
          <el-form ref="resumeForm" :model="resumeForm" :rules="rules" label-width="120px" :hide-required-asterisk="true">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="resumeForm.name" placeholder="请输入应聘人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号后4位" prop="mobile">
              <el-input v-model="resumeForm.mobile" placeholder="请输入应聘人手机号后四位" clearable></el-input>
            </el-form-item>

            <el-form-item>
              <el-button class="button-container" type="primary" @click="onSubmit('resumeForm')">验证</el-button>
              <el-button class="button-container" @click="resetForm('resumeForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
import Common from '../../../../js/Common'
import ResumeInfo from './ResumeInfo'

export default {
  name: 'Resume',
  components: {ResumeInfo},
  data () {
    return {
      resumePermissions: false,
      resumeForm: {
        name: '',
        mobile: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入应聘人姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入应聘人手机号后四位', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init () {
      if (sessionStorage.getItem(Common.resumePermissions) === 'true') {
        this.resumePermissions = true
      }
    },
    onSubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.resumeForm.name === '王瑞' || this.resumeForm.mobile === '3153') {
            this.resumePermissions = true
            sessionStorage.setItem(Common.resumePermissions, 'true')
          } else {
            this.$alert('请联系应聘人获取验证信息', '验证失败', {
              confirmButtonText: '确定'
            })
            this.resetForm('resumeForm')
          }
        } else {
          return false
        }
      })
    },
    resetForm (form) {
      this.$refs[form].resetFields()
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/resume/Resume.vue